module.exports = __webpack_public_path__ + "img/equipment-profile.7d94111d.png";